import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';
import { NsCard } from 'components/common/ns-card/NsCard';

export const EvTariffInformationSteps = () => {
  const { hasElectricitySmartMeter } = useHasSmartMeter();
  return (
    <>
      <h3>How to get our EV tariff</h3>
      <NsCard heading="1. Choose any tariff">
        <p>Join British Gas on any of our available tariffs.</p>
      </NsCard>
      {hasElectricitySmartMeter ? (
        <NsCard heading="2. Getting you set up">
          We&apos;ll set up your account and connect with your smart meter (this
          can take about two weeks).
        </NsCard>
      ) : (
        <NsCard heading="2. Book a smart meter">
          We&apos;ll set up your account and within around two weeks you can
          book your smart meter installation for no cost.
          <NsCaveatLink>
            Certain meters can&apos;t be upgraded yet.
          </NsCaveatLink>
        </NsCard>
      )}

      <NsCard heading="3. Switch to our EV tariff">
        <p>
          We&apos;ll email you once everything is ready so you can switch to our
          EV tariff.
        </p>
      </NsCard>
    </>
  );
};
